import React, {useRef} from 'react'
import * as THREE from 'three'
import {useFrame, useLoader} from "@react-three/fiber";


export default function Sky(props) {
    const move = props.move
    const mesh = useRef()
    const texture = useLoader(THREE.TextureLoader, 'https://web-cdn.tankionline.com/new-year/sky.png')

    useFrame((state, delta) => {
        if (move) {
            mesh.current.rotation.y += 0.0005
        }
    })
    return (
        <>
            <mesh rotation={[-Math.PI /6,Math.PI /2,0]} ref={mesh}>
                <sphereBufferGeometry attach="geometry" args={[400, 120, 80]}/>
                <meshBasicMaterial fog={false} attach="material" map={texture} side={THREE.BackSide}/>
            </mesh>
        </>
    )
}
